import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import AppShell from "@/pages/AppShell";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import CatalogBuilder from "@/pages/CatalogBuilder";
import PresetsPage from "@/pages/PresetsPage";
import LibraryPage from "@/pages/LibraryPage";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Detect session_id synchronously (avoids race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AppShell />}>
        <Route index element={<CatalogBuilder />} />
        <Route path="/presets" element={<PresetsPage />} />
        <Route path="/library" element={<LibraryPage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}
